﻿'use strict';

/**
* Controller for session management
* @memberOf components.sessionModule
* @namespace sessionManagementController
*/

sessionManagementController.$inject = ['sessionManagementFactory', '$uibModal', '$scope', '$state', '$timeout', 'data_project_constants', 'toaster'];

function sessionManagementController(sessionManagementFactory, $uibModal, $scope, $state, $timeout, data_project_constants, toaster) {
    /* jshint validthis:true */
    var vm = this;
    vm.title = 'sessionManagementController';
    vm.countdownTimeSpan;
    vm.initModal;
    vm.isSessionStarted = false;
    vm.currentSessionRenewalRetryCount = 0;
    vm.sessionLastChecked = 0;

    var SESSION_RENEWAL_WAIT = data_project_constants.session_event_times.session_refresh_delay;
    var NUMBER_OF_RETRIES = data_project_constants.session_management.number_of_connection_retries;
    var TOAST_TIME_OUT = data_project_constants.session_management.session_toast_visible_timespan;
    var SESSION_RESTORE_WAIT_INTERVAL = data_project_constants.session_management.session_restore_interval;

    var sessionRenewalTime = Date.now();

    /**
    * Init the timeout warning modal
    * @method initModal
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    vm.initModal = function () {
        var modal = $uibModal.open({

            templateUrl: require('./sessionTimeOutWarningModal.html'),
            controller: 'sessionTimeOutWarningModalController as sessionTimeOutWarning'

        }).result.then(function (resultItem) {
            vm.renewSession();
        }, function () {
            vm.countdownTimeSpan = 0;
            $state.go('authentication.logout');
        });
    }

    /**
    * Renew the session with the session manager
    * @method renewSession
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    vm.renewSession = function () {

        if (vm.isSessionStarted && sessionRenewalCheck()) {
            refreshSessionRetry(NUMBER_OF_RETRIES);
        }
    }

    //register for events
    sessionManagementFactory.subscribeToSessionManagementEvent(sessionManagementFactory.sessionManagementEvents().SessionStart, $scope, sessionStartHandler);
    sessionManagementFactory.subscribeToSessionManagementEvent(sessionManagementFactory.sessionManagementEvents().SessionWarning, $scope, sessionWarningHandler);
    sessionManagementFactory.subscribeToSessionManagementEvent(sessionManagementFactory.sessionManagementEvents().SessionEnd, $scope, sessionEndHandler);

    /**
    * Helper method that handles the session start event from the session manager
    * @method sessionStartHandler
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    function sessionStartHandler() {
        vm.isSessionStarted = true
    }

    /**
    * Helper method that handles the session warning event from the session manager
    * @method sessionWarningHandler
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    function sessionWarningHandler() {
        vm.countdownTimeSpan = sessionManagementFactory.timeLeftInSession() / 1000;
        vm.initModal();
    }

    /**
    * Helper method that handles the session end event from the session manager
    * @method sessionEndHandler
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    function sessionEndHandler() {
        vm.isSessionStarted = false;
    }

    /**
    * Helper method to make sure that we are only banging on the session factory every SESSION_RENEWAL_WAIT number of seconds
    * @method sessionRenewalCheck
    * @returns {Boolean} true if we can call the session factory and false if we cannot
    * @memberOf components.sessionModule.sessionManagementController
    */
    function sessionRenewalCheck() {
        //create new date on the calling of this function
        vm.sessionLastChecked = Date.now();

        if ((vm.sessionLastChecked >= sessionRenewalTime) && (vm.currentSessionRenewalRetryCount == 0)) {
            sessionRenewalTime = new Date(Date.now() + SESSION_RENEWAL_WAIT);
            return true;
        }
        else {
            return false;
        }
    }

    /**
    * Helper method to retry refreshing the authentication object 
    * @method refreshSessionRetry
    * @param {int} passedMaxRetries number of times to retry to connect
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    function refreshSessionRetry(passedMaxRetries) {
        sessionManagementFactory.renewSession().then(function () {

            //we only need to show the connection restored if there was an issue in the first place
            if (passedMaxRetries < NUMBER_OF_RETRIES) {
                toaster.pop({
                    type: 'success',
                    title: 'Connection Restored',
                    body: "{ template: 'angular/components/uielements/notifications/successNotification.html', data: 'Connection has been restored'}",
                    bodyOutputType: 'templateWithData',
                    showCloseButton: true,
                    timeout: TOAST_TIME_OUT
                });

                vm.currentSessionRenewalRetryCount = 0;
            }

        }, function () {

            if (passedMaxRetries > 0) {

                toaster.pop({
                    type: 'error',
                    title: 'Connection Lost',
                    body: "{ template: 'angular/components/uielements/notifications/errorNotification.html', data: 'Trying to restore connection number of retries left: " + passedMaxRetries + "'}",
                    bodyOutputType: 'templateWithData',
                    showCloseButton: true,
                    timeout: TOAST_TIME_OUT
                });

                passedMaxRetries = --passedMaxRetries;
                vm.currentSessionRenewalRetryCount = NUMBER_OF_RETRIES - passedMaxRetries;

                $timeout(function () { refreshSessionRetry(passedMaxRetries) }, SESSION_RESTORE_WAIT_INTERVAL);
            }
            else if (passedMaxRetries == 0) {
                toaster.pop({
                    type: 'error',
                    title: 'Connection Lost',
                    body: "{ template: 'angular/components/uielements/notifications/errorNotification.html', data: 'We are sorry but we are unable to reestablish connection'}",
                    bodyOutputType: 'templateWithData',
                    showCloseButton: true,
                    timeout: 0
                });

                //end the session here
                vm.isSessionStarted = false;
            }

        });
    }
}

module.exports = sessionManagementController;


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/session/sessionManagementController.js
// module id = 29
// module chunks = 0